import React, { FunctionComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { Field, FormikErrors, FormikValues } from "formik";
import RadioButton from "../../../shared/publicForms/RadioButton";
import TextField from "../../../shared/publicForms/TextField";
import {
  RadioButtonGroupWrapper,
  RadioButtonGroup,
} from "../../styles/diversity-form-styles";

export interface ICaringResponsibilitiesProps {
  values: {
    caringResponsibilities?: null | string;
    caringResponsibilitiesType?: null | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
  formLoading: boolean;
}

const Yes: FunctionComponent<ICaringResponsibilitiesProps> = ({
  values,
  setFieldValue,
  formLoading,
}) => {
  const radioButtonOptions = [
    null,
    "Primary carer for an older person",
    "Primary carer of a child/children (under 18)",
    "Primary carer of a disabled person (over 18)",
    "Secondary carer",
    "Other",
  ];
  const { caringResponsibilitiesType } = values;

  return (
    <RadioButtonGroupWrapper
      role="group"
      marginTop={22}
      aria-labelledby="caringResponsibilities-radio-group"
    >
      <RadioButtonGroup width={390}>
        {radioButtonOptions
          .filter((option) => option)
          .map((option) =>
            option === "Other" ? (
              <Fragment key={option}>
                <Field
                  name="caringResponsibilitiesType"
                  type="radio"
                  aria-label={option}
                  label={option}
                  value={option}
                  disabled={formLoading}
                  onChange={() =>
                    setFieldValue("caringResponsibilitiesType", "", true)
                  }
                  checked={
                    !radioButtonOptions.includes(caringResponsibilitiesType)
                  }
                  as={RadioButton}
                />
                {!radioButtonOptions.includes(caringResponsibilitiesType) && (
                  <Field
                    name="caringResponsibilitiesType"
                    type="text"
                    disabled={formLoading}
                    aria-label={caringResponsibilitiesType}
                    placeholder="Please specify"
                    as={TextField}
                  />
                )}
              </Fragment>
            ) : (
              <Field
                key={option}
                name="caringResponsibilitiesType"
                type="radio"
                aria-label={option}
                label={option}
                value={option}
                disabled={formLoading}
                as={RadioButton}
              />
            )
          )}
      </RadioButtonGroup>
    </RadioButtonGroupWrapper>
  );
};

Yes.propTypes = {
  values: PropTypes.shape({
    caringResponsibilities: PropTypes.string,
    caringResponsibilitiesType: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    caringResponsibilities: PropTypes.string,
    caringResponsibilitiesType: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  formLoading: PropTypes.bool.isRequired,
};

export default Yes;
